// extracted by mini-css-extract-plugin
module.exports = {"partners__hgroup":"_a7","partners":"_a8","partners__list":"_a9","partners__logo":"_a-"};